/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getJourneyMap = /* GraphQL */ `
  query GetJourneyMap($id: ID!) {
    getJourneyMap(id: $id) {
      id
      owner
      title
      version
      preview
      updatedAt
      createdAt
      collaborators {
        items {
          mapId
          user
          type
          createdAt
        }
        nextToken
      }
    }
  }
`;
export const listJourneyMapsByOwnerSortedByUpdatedAt = /* GraphQL */ `
  query ListJourneyMapsByOwnerSortedByUpdatedAt(
    $owner: String!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelJourneyMapFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJourneyMapsByOwnerSortedByUpdatedAt(
      owner: $owner
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        title
        version
        preview
        updatedAt
        createdAt
        collaborators {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getMapOperation = /* GraphQL */ `
  query GetMapOperation($id: ID!) {
    getMapOperation(id: $id) {
      id
      owner
      mapId
      type
      data
      createdAt
      updatedAt
    }
  }
`;
export const listMapOperation = /* GraphQL */ `
  query ListMapOperation(
    $mapId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMapOperationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMapOperation(
      mapId: $mapId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        mapId
        type
        data
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getJourneyMapOperation = /* GraphQL */ `
  query GetJourneyMapOperation($mapId: ID!, $seq: Int!) {
    getJourneyMapOperation(mapId: $mapId, seq: $seq) {
      mapId
      seq
      owner
      type
      data
      createdAt
    }
  }
`;
export const listJourneyMapOperations = /* GraphQL */ `
  query ListJourneyMapOperations(
    $mapId: ID
    $seq: ModelIntKeyConditionInput
    $filter: ModelJourneyMapOperationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listJourneyMapOperations(
      mapId: $mapId
      seq: $seq
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        mapId
        seq
        owner
        type
        data
        createdAt
      }
      nextToken
    }
  }
`;
export const getJourneyMapCollaborator = /* GraphQL */ `
  query GetJourneyMapCollaborator($mapId: ID!, $user: String!) {
    getJourneyMapCollaborator(mapId: $mapId, user: $user) {
      mapId
      user
      type
      createdAt
      map {
        id
        owner
        title
        version
        preview
        updatedAt
        createdAt
        collaborators {
          nextToken
        }
      }
    }
  }
`;
export const listJourneyMapCollaborators = /* GraphQL */ `
  query ListJourneyMapCollaborators(
    $mapId: ID
    $user: ModelStringKeyConditionInput
    $filter: ModelJourneyMapCollaboratorFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listJourneyMapCollaborators(
      mapId: $mapId
      user: $user
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        mapId
        user
        type
        createdAt
        map {
          id
          owner
          title
          version
          preview
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const listJourneyMapCollaboratorsByUser = /* GraphQL */ `
  query ListJourneyMapCollaboratorsByUser(
    $user: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelJourneyMapCollaboratorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJourneyMapCollaboratorsByUser(
      user: $user
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        mapId
        user
        type
        createdAt
        map {
          id
          owner
          title
          version
          preview
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const getMapTemplate = /* GraphQL */ `
  query GetMapTemplate($id: ID!) {
    getMapTemplate(id: $id) {
      id
      owner
      category
      title
      preview
      data
      createdAt
      updatedAt
    }
  }
`;
export const listMapTemplates = /* GraphQL */ `
  query ListMapTemplates(
    $filter: ModelMapTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMapTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        category
        title
        preview
        data
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getMapMeta = /* GraphQL */ `
  query GetMapMeta($mapId: ID!) {
    getMapMeta(mapId: $mapId) {
      mapId
      version
      collaboratorType
    }
  }
`;
export const listDashboardMaps = /* GraphQL */ `
  query ListDashboardMaps {
    listDashboardMaps {
      mapId
      owner
      title
      version
      preview
      updatedAt
      createdAt
      collaboratorType
      isCollaborated
    }
  }
`;
export const listOperations = /* GraphQL */ `
  query ListOperations($mapId: ID!, $beginSeq: Int, $nextToken: String) {
    listOperations(mapId: $mapId, beginSeq: $beginSeq, nextToken: $nextToken) {
      items {
        mapId
        seq
        owner
        type
        data
        createdAt
      }
      nextToken
    }
  }
`;
export const findUser = /* GraphQL */ `
  query FindUser($email: String!) {
    findUser(email: $email)
  }
`;
export const getUserEmailOrNull = /* GraphQL */ `
  query GetUserEmailOrNull($userId: String!) {
    getUserEmailOrNull(userId: $userId)
  }
`;
export const listCollaborators = /* GraphQL */ `
  query ListCollaborators($mapId: ID!) {
    listCollaborators(mapId: $mapId) {
      user
      email
      type
    }
  }
`;
